export const POPUP_SET_REF = 'POPUP_SET_REF';

export const popupSetRef = (ref) => ({
    type: POPUP_SET_REF,
    payload: ref
});

export const POPUP_UNSET_REF = 'POPUP_UNSET_REF';

export const popupUnsetRef = () => ({
    type: POPUP_UNSET_REF
});

export const POPUP_SHOW = 'POPUP_SHOW';

export const popupShow = (id) => ({
    type: POPUP_SHOW,
    payload: id
});

export const POPUP_HIDE = 'POPUP_HIDE';

export const popupHide = () => ({
    type: POPUP_HIDE
});

export const POPUP_POSITION = 'POPUP_POSITION';

export const popupPosition = (el) => ({
    type: POPUP_POSITION,
    payload: el
});

export const POPUP_UNSET_PARENT_REF = 'POPUP_UNSET_PARENT_REF';

export const popupUnsetParentRef = (el) => ({
    type: POPUP_UNSET_PARENT_REF,
    payload: el
});

export const POPUP_REPOSITION = 'POPUP_REPOSITION';

export const popupReposition = () => ({
    type: POPUP_REPOSITION
});



// WEBPACK FOOTER //
// ./src/store/actions/popup.js